export default "__VITE_ASSET__C$ZacxcZ__"